// =====================================
//
//   Topbar
//   Author: Mark
//   createtime: 2019 / 02 / 13
//   updatetime: 2019 / 02 / 13
//
// =====================================


window.InifECMobileApp.directive('topbar', ['$rootScope', '$state', '$timeout', 'UserService',
    function($rootScope, $state, $timeout, UserService) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

		let toggleSearch = function() {
			$scope.isSearch = !$scope.isSearch
			if($scope.isSearch) {
				$timeout(function() {
					$('#topbar-search-input').focus()
				}, 350)
			}
		}
		let submit = function() {
			if(!$scope.form.keyword) return
			$scope.isSearch = false
            if($scope.form.keyword) {
                $state.go(window.STATES.SEARCH_PDT, {
                    keyword: $scope.form.keyword
				});
				$scope.form.keyword = ''
            }
		}

		// -------------------------------
        // 登入
        // -------------------------------
        var login = function() {
            
            $rootScope.$broadcast('OPEN_LOGIN_MODAL');
		}
		
		// -------------------------------
        // 註冊
        // -------------------------------
        var register = function() {
            
            $rootScope.$broadcast('OPEN_REGISTER_MODAL');
		}
		
		// --------------------------------
		// 取得使用者資訊
		// --------------------------------
		var getUserInfo = function(skipCache) {

			UserService.getUserInfo(skipCache).then(function(result) {
				$scope.isLogin = true;
			}, function(error) {
				$scope.isLogin = false;
			});
		}

		var init = function() {
			getUserInfo();
		}

		//==========================
		//  Events
		//==========================
		$scope.$on('LOGIN_SUCCESS', function(event, data){
			$scope.isLogin = true;
		});

		$scope.$on('LOGOUT_SUCCESS', function(event, data){
			$scope.isLogin = false;
		});

        //==========================
        //  Init
        //==========================
		init();
		
		$scope.isSearch = false
		$scope.isLogin = false;
		$scope.toggleSearch = toggleSearch
		$scope.submit = submit
		$scope.login = login
		$scope.register = register
		$scope.form = {
			keyword: ''
		};

	}];

	_dir.restrict = 'E';
	_dir.scope = true;
	_dir.templateUrl = "mobile/partials/directives/topbar.html";
	_dir.controller = controller;

	return _dir;

}]);
